<template>
  <!-- 资金统计 -->
  <div class="capital-statistical-wrapper edge-width-padding">
    <MoreTitle title="当日资金统计" no-split no-edge-padding>
      <template #right>
        <span class="unit-box">{{ $t('单位') }}：{{ $t(divisorUnit[1]) }}</span>
      </template>
    </MoreTitle>
    <div class="chart-wrap">
      <div class="legend-container">
        <div v-for="item in statisticalLegend" :key="item.label" class="legend-item">
          <span class="legend-label">{{ $t(item.label) }}：</span>
          <span :style="{ color: item.color }">{{ item.value }}</span>
        </div>
      </div>
      <VueEcharts :option="option" />
    </div>
  </div>
</template>

<script>
import VueEcharts from '@/components/common/VueEcharts.vue'
import { i18nTranslateInit } from '@/utils/utility-lang'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { VueEcharts },
  inject: ['theme'],
  props: ['data', 'divisorUnit'],
  data() {
    return {
      useOpenCC: i18nTranslateInit.useOpenCC
    }
  },
  computed: {
    isUs() {
      return this.$route.query?.symbol?.includes('.us')
    },
    capitalInTotal() {
      return this.$digitjs(this.data.capitalInTotal).convert(this.isUs ? 4 : 2, this.divisorUnit[0])
    },
    capitalOutTotal() {
      return this.$digitjs(this.data.capitalOutTotal).convert(this.isUs ? 4 : 2, this.divisorUnit[0])
    },
    capitalNetIn() {
      const { capitalInTotal, capitalOutTotal } = this.data
      const capitalNetIn = capitalInTotal - capitalOutTotal
      return this.$digitjs(capitalNetIn).convert(this.isUs ? 4 : 2, this.divisorUnit[0])
    },
    statisticalLegend() {
      return [
        {
          label: '流入',
          value: this.capitalInTotal,
          color: this.theme['--up-color']
        },
        {
          label: '流出',
          value: this.capitalOutTotal,
          color: this.theme['--down-color']
        },
        {
          label: '净额',
          value: this.capitalNetIn,
          color: this.$digitjs(this.capitalNetIn).color()
        }
      ]
    },
    statisticalData() {
      const {
        capitalInLarge,
        capitalInBig,
        capitalInMid,
        capitalInSmall,
        capitalOutLarge,
        capitalOutBig,
        capitalOutMid,
        capitalOutSmall
      } = this.data
      const divisor = this.divisorUnit[0]
      return [
        {
          name: this.useOpenCC('特大单'),
          value: this.$digitjs(capitalInLarge - capitalOutLarge).convert(this.isUs ? 4 : 2, divisor)
        },
        {
          name: this.useOpenCC('大单'),
          value: this.$digitjs(capitalInBig - capitalOutBig).convert(this.isUs ? 4 : 2, divisor)
        },
        {
          name: this.useOpenCC('中单'),
          value: this.$digitjs(capitalInMid - capitalOutMid).convert(this.isUs ? 4 : 2, divisor)
        },
        {
          name: this.useOpenCC('小单'),
          value: this.$digitjs(capitalInSmall - capitalOutSmall).convert(this.isUs ? 4 : 2, divisor)
        }
      ]
    },
    option() {
      return {
        grid: {
          top: postcssPatch(15),
          bottom: postcssPatch(15),
          left: postcssPatch(40),
          right: postcssPatch(40),
          containLabel: true
        },
        visualMap: {
          show: false,
          pieces: [
            { gt: 0, color: this.theme['--up-color'] },
            { lt: 0, color: this.theme['--down-color'] },
            { value: 0, color: this.theme['--flat-color'] }
          ]
        },
        dataset: {
          source: this.statisticalData
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            margin: 20,
            color: this.theme['--font-color-3']
          },
          axisLine: {
            lineStyle: {
              color: this.theme['--border-color-1']
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: 'bar',
            barMaxWidth: 15,
            encode: {
              x: 'name',
              y: 'value'
            },
            label: {
              show: true,
              color: 'inherit',
              fontSize: 12,
              position: 'bottom'
            },
            labelLayout({ text, rect }) {
              const value = Number(text)
              if (value < 0) {
                return {
                  y: rect.y - 13,
                  align: 'center'
                }
              }
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.capital-statistical-wrapper {
  margin-top: 20px;
  background: var(--bg-color-2);
  .unit-box {
    font-size: 12px;
    font-weight: 500;
    color: var(--font-color-3);
  }
  .chart-wrap {
    .legend-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-bottom: 40px;
      white-space: nowrap;
      color: var(--font-color-1);
    }
    .legend-item {
      display: flex;
    }
    .legend-label {
      margin-right: 5px;
    }
  }
}
</style>
